import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function contains(value: any, index_start?, index_end?): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    let contains_value =
      index_start && index_end && index_start > 0 && index_end < value.length
        ? value.substring(index_start, index_end)
        : value;

    return !control.value.includes(contains_value) ? { contains: true } : null;
  };
}
